// extracted by mini-css-extract-plugin
module.exports = {"HiredBuses":"HiredBuses_HiredBuses__2Yf2I"};